export default {
  identity: process.env.VUE_APP_IDENTITY_API_HOST,
};
